import React from "react";
import { DropdownFieldDefinition, FormField, SharedFormFieldProps } from "./types";
import { Translated } from "../../../../../../../domain/translations/translations";
import { CheckoutTranslation, type TranslatedValue } from "@swo/storefront";
import { InternalAddress } from "./address";
import { SwarovskiDropdown2 } from "../../../shared/SwarovskiDropdown";
import { swarovskiDropdownStyles } from "./CheckoutAddressFormEditor";
import { fontColor, FONTS, fontSize } from "../../../../../../../styles/fonts";
import { css } from "@emotion/react";
import { disabledFormStyles } from "../../../shared/form/DisabledFormStyles";
import { errorMessageStyles } from "../../../shared/form/errorMessageStyles";
import cn from "classnames";
import { CSS_COLORS } from "../../../../../../../styles/styles-css-variables";

type Props = {
  def: SharedFormFieldProps & {
    field: DropdownFieldDefinition;
  };
  element: FormField;
  translations: Translated<CheckoutTranslation>;
  formStateValue: InternalAddress;
  errorMessage?: TranslatedValue | string;
};

export const SwarovskiOptikStyledDropdown: React.FC<Props> = ({
  def,
  translations,
  formStateValue,
  errorMessage,
  element,
}) => {
  const selected = def.field.values.find(i => i.value === def.field.value(formStateValue)) || def.field.emptyValue;

  const label = `${translations("addressForm.state").value}`;

  return (
    <div
      key={`${def.key}-${def.field.value(formStateValue)}`}
      className={cn(!!def.disabled ? "disabled" : undefined, { "has-error": !!errorMessage })}
      css={dropdownStyles}
    >
      {typeof element.placeholder !== "undefined" && (
        <span
          css={[
            fontSize.x2,
            css`
              position: absolute;
              left: 12px;

              top: -0.4em;

              background: var(--bg-error);

              transform: scale(0.75);
              transform-origin: top left;
            `,
          ]}
        >
          {element.placeholder}
        </span>
      )}

      <SwarovskiDropdown2
        disabled={!!def.disabled}
        required={!!def.required}
        attachStyles={swarovskiDropdownStyles}
        selected={selected}
        emptyLabel={`${label}*`}
        name={"state"}
        onChange={def.field.onChange}
        options={def.field.values}
      />

      {typeof errorMessage === "string" && <span css={errorMessageStyles}>{errorMessage}</span>}
    </div>
  );
};

const dropdownStyles = [
  FONTS.SwarovskiFutura300,
  fontColor.black,
  fontSize.x25,
  css`
    height: 40px;
    position: relative;

    border: 1px solid var(--so-green);
    border-radius: 8px;
    padding: 0 12px;

    &:focus-within {
      outline: 1px solid var(--so-green);
    }

    --bg-error: ${CSS_COLORS.GrayLight2024};
    --text-error: ${CSS_COLORS.RedCustom};

    &.has-error {
      background: var(--bg-error);
      color: var(--text-error);
    }

    &.disabled {
      ${disabledFormStyles};
    }
  `,
];
